import React, {useEffect} from 'react';
import '../styles/Pages.css';

const CentroConvivencia = () => {
    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/e058bc189010149.65f46a4aa780e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/05b642189010149.65f773c254de0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/5443a2189010149.65f47d58e0d7d.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/c0824a189010149.65f36341d5c5e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/e85477189010149.65f5db7510a38.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/f0f2f1189010149.65fc931d5abf2.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/fa92b3189010149.65f5db750fd87.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/8dcf60189010149.65f46a4aa67cb.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/ab9511189010149.65aea64538b8e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/cbf3b4189010149.65f1e05d2dca1.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/51709f189010149.65f1f03f99cad.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/285185189010149.65f46a4aa5a55.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5a31b3189010149.65ef6150bb806.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4c3209189010149.65f1fe8a77faa.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/a0ae2d189010149.65f46a4aa85bb.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/bb53a9189010149.65aea6453615f.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/c2b8a4189010149.65f1fe8a75f1e.png'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };

      }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Centro de Convivência</h1>
                    <p className="subtitle">O Centro de Convivência é um farol de esperança para aqueles que procuram um propósito renovador na jornada da vida.</p>
                </div>
                <div className="pages-right">
                    <p className="description">
                        O Centro de Convivência é um programa da empresa EVIDA - Assistência à Saúde, onde tudo é mais do que um espaço físico; é um refúgio de calor humano e compaixão, especialmente dedicado aos idosos em busca de significado e conexão.
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Centro de Convivência Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default CentroConvivencia;
